<template>
  <div class="page page--fill">
    <data-list
      v-if="$env.billing"
      title="Consommations"
      client="billing"
      resource="lines"
      :columns="columns"
      :filters="filters">
      <template #code="{ item }">
        <span class="cell-mono">{{ item.code }}</span>
      </template>
    </data-list>
    <billing-unavailable v-else />
  </div>
</template>

<script>
  import DataList from '../components/DataList'
  import BillingUnavailable from '../components/BillingUnavailable'
  import { formatDate, formatPrice, monthRange } from '../labels'

  export default {
    name: 'BillsRow',
    components: { DataList, BillingUnavailable },
    data () {
      return {
        columns: [
          { key: 'code', label: 'Code', width: 160 },
          { key: 'account.name', label: 'Compte' },
          { key: 'price', label: 'Prix', width: 140, align: 'end', format: formatPrice },
          { key: 'date', label: 'Date', width: 120, format: formatDate }
        ],
        filters: [
          { key: 'month', type: 'month', label: 'Mois', toParams: monthRange }
        ]
      }
    }
  }
</script>
